var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgStar = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M8.41180398,7.57484957 L11.3274695,1.66803206 C11.602596,1.11065598 12.397404,1.11065598 12.6725305,1.66803206 L15.588196,7.57484957 L22.1084712,8.52788545 C22.7234072,8.61776756 22.9684947,9.37364851 22.5232996,9.80726858 L17.8058913,14.4020242 L18.9192065,20.8932175 C19.0242954,21.5059392 18.3811337,21.9731615 17.8309115,21.6838051 L12,18.6173872 L6.16908846,21.6838051 C5.61886628,21.9731615 4.97570464,21.5059392 5.08079354,20.8932175 L6.19410866,14.4020242 L1.4767004,9.80726858 C1.03150525,9.37364851 1.27659284,8.61776756 1.89152884,8.52788545 L8.41180398,7.57484957 Z M12,3.69444075 L9.58253051,8.59196794 C9.47337571,8.81310356 9.2624868,8.96644801 9.01847116,9.00211455 L3.61130875,9.79245233 L7.5232996,13.6027314 C7.7002049,13.7750372 7.78095187,14.0233855 7.73920646,14.2667825 L6.81613559,19.648755 L11.6509115,17.1061949 C11.8694487,16.9912684 12.1305513,16.9912684 12.3490885,17.1061949 L17.1838644,19.648755 L16.2607935,14.2667825 C16.2190481,14.0233855 16.2997951,13.7750372 16.4767004,13.6027314 L20.3886913,9.79245233 L14.9815288,9.00211455 C14.7375132,8.96644801 14.5266243,8.81310356 14.4174695,8.59196794 L12,3.69444075 Z"
  }));
};
export default SvgStar;